module.exports = __webpack_public_path__ + "static/media/accept-icon.6ea5b0ce.svg";